import { env } from '@website/env';

export function constructImageUrl(key?: string) {
  if (!key) {
    return undefined;
  }

  return `${env.NEXT_PUBLIC_STORAGE_BASE_URL}/${key}`;
}

export function filterObjectByValues<T, U>(
  obj: Record<string, T>,
  valuesToExclude: T[],
): U {
  return Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => !valuesToExclude.includes(value)),
  ) as U;
}
